import statisticSvc from "../../services/api/statistic"
import parameterSvc from "../../services/api/parameter"
import { useState, useEffect } from "react"
import { notify } from "../../common/notificationService"
import { useLookupStation } from "../../utils/get-lookup"
import dayjs from "dayjs";
import Select from 'react-select';
import ReactSelectComponent from "../../components/react-select";
import { listDateFilter, listExportType } from "../../utils/helper";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import { StatisticNumberOfTimesExceededDataItem } from "../../models/types/statistic";
import StatisticTable from "./table";
import { Download } from "lucide-react";
import { useResponsive } from "../../hooks/mediaQuery";
import { useTranslation } from "react-i18next"
//model
const StatisticNumberOfTimesExceededPage = () => {
    const { lookupStation } = useLookupStation();
    const { isXs } = useResponsive();
    const { t } = useTranslation();
    const today = dayjs();
    const [filterParams, setFilterParams] = useState<any>({
        stationIds: [],
        from: listDateFilter[0].from,
        to: listDateFilter[0].to,
    });

    const [listParameterByStation, setListParameterByStation] = useState<any[]>([]);
    const [listVisibleParameter, setListVisibleParameter] = useState<any[]>([]);
    const [rangeDate, setRangeDate] = useState<any>(listDateFilter[0].value);
    const [errorDate, setErrorDate] = useState<string>('');
    const [exportType, setExportType] = useState<'excel' | 'pdf'>('excel');
    const [staticData, setStaticData] = useState<StatisticNumberOfTimesExceededDataItem[] | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const selectDay: string = rangeDate === 4 && filterParams.from && filterParams.to ?
        '(Từ ' + dayjs(filterParams.from).format('DD/MM/YYYY') + ' đến ' + dayjs(filterParams.to).format('DD/MM/YYYY') + ')'
        : t('statisticData.reports.today');

    const fetchData = async (params: any) => {
        setLoading(true);
        try {
            const response = await statisticSvc.getNumberOfTimesExceeded(params);
            if (response) {
                if (response.content) {
                    setStaticData(response.content);
                } else {
                    setStaticData(null);
                }
            }
        } catch (error) {
            console.error(error);
            notify(t('common.error'), t('common.errorMessage'), "danger");
        } finally {
            setLoading(false);
        }
    }

    const getListParameterByStation = async (stationIds: number[]) => {
        try {
            const response = await parameterSvc.getLookupByStation(stationIds);
            if (response) {
                if (response.content) {
                    setListParameterByStation(response.content);
                    setListVisibleParameter(response.content);
                } else {
                    setListParameterByStation([]);
                    setListVisibleParameter([]);
                }
            }
        } catch (error) {
            console.error(error);
            notify(t('common.error'), t('common.errorMessage'), "danger");
        }
    }
    useEffect(() => {
        if (filterParams.stationIds.length > 0) {
            getListParameterByStation(filterParams.stationIds);
        } else {
            setListParameterByStation([]);
            setListVisibleParameter([]);
        }
    }, [filterParams.stationIds]);

    const handleExport = async () => {
        try {
            const response = await statisticSvc.exportNumberOfTimesExceeded({ ...filterParams, fileType: exportType });
            if (response) {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'statistic_number_of_times_exceeded_data_(' + dayjs(filterParams.from).format('DD-MM-YYYY') + '_' + dayjs(filterParams.to).format('DD-MM-YYYY') + ')' + (exportType === 'excel' ? '.xlsx' : '.pdf'));
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        } catch (error) {
            console.error(error);
            notify(t('common.error'), t('common.errorMessage'), "danger");
        }
    }

    useEffect(() => {
        let params = filterParams;
        console.log(params);
        if (params.stationIds.length === 0) {
            setStaticData(null);
            return;
        }
        if (params.stationIds.length > 0 && params.from && params.to) {
            fetchData(params);
        } else if (rangeDate !== 4) {
            setStaticData(null);
        }
    }, [filterParams]);

    const handleChangeWMParams = (params: any) => {
        setFilterParams({ ...filterParams, ...params });
    }

    const handleDateChange = (params: any) => {
        console.log(params);
        if (!params[0] || !params[1]) {
            setErrorDate(t('statisticNumberOfTimesExceeded.pleaseSelectTimeRange'));
            return;
        }
        const from = dayjs(params[0]);
        const to = dayjs(params[1]);

        if (validateDate(from, to)) {
            setFilterParams({ ...filterParams, from: from.format('YYYY-MM-DD HH:mm'), to: to.add(1439, 'minute').format('YYYY-MM-DD HH:mm') });
            setErrorDate('');
        }
    }

    const validateDate = (from: dayjs.Dayjs, to: dayjs.Dayjs) => {
        if (from.isAfter(to)) {
            setErrorDate(t('statisticNumberOfTimesExceeded.startDateMustBeBeforeEndDate'));
            return false;
        }
        return true;
    }

    return (
        <div className="page-wrapper h-full w-full">
            <div className="h-full flex flex-col">
                <div className={`rounded-lg border border-gray-200 shadow-sm bg-white ${isXs ? 'p-2' : 'p-4'} mb-2`}>
                    <div className={`flex flex-wrap items-center ${isXs ? 'gap-2' : 'gap-4'}`}>
                        <div className={`${isXs ? 'w-full' : 'min-w-[250px]'}`}>
                            <label className="block text-sm font-medium text-gray-700">{t('statisticData.station')} <span className="text-red-500">*</span></label>
                            <ReactSelectComponent
                                options={
                                    lookupStation.length === filterParams.stationIds.length ?
                                        lookupStation : [{ label: t('statisticData.selectAll'), value: '*' }, ...lookupStation]
                                }
                                value={filterParams.stationIds.map((item: any) => lookupStation.find((option: any) => option.value === item))}
                                onChange={(selected: any) => {
                                    if (!selected || selected.length === 0) {
                                        setFilterParams({ ...filterParams, stationIds: [] });
                                        return;
                                    }
                                    if (selected.some((option: any) => option.value === '*')) {
                                        setFilterParams({ ...filterParams, stationIds: lookupStation.map((item: any) => item.value) });
                                    } else {
                                        setFilterParams({ ...filterParams, stationIds: selected.map((item: any) => item.value) });
                                    }
                                }}
                                isMulti
                                noOptionsMessage={t('statisticData.selectAll')}
                                placeholder={t('statisticData.selectStation')}
                            />
                        </div>
                        <div className={`flex flex-wrap items-center gap-4 ${isXs ? 'w-full' : 'min-w-[250px]'}`}>
                            <div className={`${isXs ? 'w-full' : 'min-w-[250px]'}`}>
                                <label className="block text-sm font-medium text-gray-700">{t('statisticData.timeRange')} <span className="text-red-500">*</span></label>
                                <Select
                                    className="w-full"
                                    options={listDateFilter}
                                    placeholder={t('statisticData.selectTimeRange')}
                                    isDisabled={filterParams.stationIds.length === 0}
                                    value={listDateFilter.find(option => option.value === rangeDate)}
                                    onChange={(e: any) => {
                                        handleChangeWMParams({ from: e.from, to: e.to });
                                        setRangeDate(e.value);
                                    }}
                                    isSearchable={false}
                                />
                            </div>
                            {rangeDate === 4 && (
                                <div className={`${isXs ? 'w-full' : 'min-w-[290px]'}`}>
                                    <label className="block text-sm font-medium text-gray-700">{t('statisticData.customTimeRange')} <span className="text-red-500">*</span></label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateRangePicker
                                            format="DD/MM/YYYY"
                                            className="date-range-picker w-full"
                                            onChange={(e: any) => handleDateChange(e)}
                                            maxDate={today}
                                        />
                                    </LocalizationProvider>
                                    {errorDate && <p className="text-red-500 text-xs mt-1">{errorDate}</p>}
                                </div>
                            )}
                        </div>
                        <div className={`${isXs ? 'w-full' : 'min-w-[250px]'}`}>
                            <label className="block text-sm font-medium text-gray-700">{t('statisticData.parameter')}</label>
                            <ReactSelectComponent
                                options={
                                    listParameterByStation.length === listVisibleParameter.length ?
                                        listParameterByStation : [{ label: t('statisticData.selectAll'), value: '*' }, ...listParameterByStation]
                                }
                                value={listVisibleParameter}
                                onChange={(selected: any) => {
                                    if (!selected || selected.length === 0) {
                                        setListVisibleParameter([]);
                                        return;
                                    }
                                    if (selected.some((option: any) => option.value === '*')) {
                                        setListVisibleParameter(listParameterByStation);
                                    } else {
                                        setListVisibleParameter(selected.map((item: any) => listParameterByStation.find((option: any) => option.value === item.value)));
                                    }
                                }}
                                isMulti
                                noOptionsMessage={t('statisticData.selectAll')}
                                placeholder={t('statisticData.selectParameter')}
                            />
                        </div>
                    </div>
                </div>

                <div className={`flex-1 flex relative overflow-y-auto flex-col rounded-lg border border-gray-200 shadow-sm bg-white ${isXs ? 'px-2' : 'px-4'}`}>
                    <div className="h-full w-full flex flex-col">
                        <div className="flex items-center justify-between mt-2">
                            <div className="flex flex-1 justify-center">
                                <h2 className="uppercase font-bold">{t('statisticData.reports.numberOfTimesExceeded')} {selectDay}</h2>
                            </div>
                            {staticData ? (
                                <div className="bg-white flex flex-wrap items-center justify-between gap-4">
                                    <div className="flex flex-wrap items-center gap-4">
                                        <div className={`flex items-center align-center border border-gray-300 rounded ${isXs ? 'text-xs' : 'text-base'}`}>
                                            <div
                                                className={`flex items-center align-center font-medium text-gray-700 p-2 bg-gray-100 cursor-pointer hover:bg-gray-200 ${isXs ? 'text-xs' : 'text-base'}`}
                                                onClick={() => handleExport()}
                                            >
                                                <Download size={isXs ? 14 : 16} className="mr-2" />export
                                            </div>
                                            <Select
                                                className="w-full"
                                                options={listExportType}
                                                placeholder={t('statisticData.selectExportType')}
                                                value={listExportType.find(option => option.value === exportType)}
                                                onChange={(e: any) => setExportType(e.value)}
                                                isSearchable={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {staticData ? (
                            <div className="flex-1 mt-3">
                                <StatisticTable staticData={staticData} listVisibleParameter={listVisibleParameter} loading={loading} />
                            </div>
                        ) : filterParams.stationIds.length === 0 ? (
                            <div className="flex flex-1 items-center justify-center">
                                <div className="text-gray-600">{t('statisticData.selectStationToShowData')}</div>
                            </div>
                        ) : (
                            <div className="flex flex-1 items-center justify-center">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatisticNumberOfTimesExceededPage;
